import Post, {IPost} from '@/models/Post'

export interface IKnowHow extends IPost {
}

export default class KnowHow extends Post {
  constructor(defaults?: IKnowHow) {
    super(defaults)
    if (defaults) {
    }
  }

  get className(): string {
    return KnowHow.name
  }
}
